import {ApiClientService, EntityApiService} from "@dfl/react-security";


class SystemLanguage extends EntityApiService<string[]> {

    systemLanguage = () => this.handleResponse(ApiClientService.get(this.getPath('/languages')))


}

export default new SystemLanguage('/ms-auth/api/system');
